import { aptGenerationApi } from '@/api/apt_generation.api';
import type { HoleObjectModel } from '@/types/apt_generation.types';
import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

export const useHoles = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchHoles = useCallback(async (extractionId: string): Promise<HoleObjectModel[]> => {
    setIsLoading(true);
    setError(null);

    try {
      const data = await aptGenerationApi.getHolesByExtractionId(extractionId);
      return data;
    } catch (_err) {
      const message = 'Failed to load holes';
      setError(message);
      toast.error(message);
      return [];
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    fetchHoles,
    isLoading,
    error,
  };
};
